"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShieldOfSylvieAbilityHandler = exports.ShieldOfSylvieActorAbilityFactory = exports.ShieldOfSylvieAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
class ShieldOfSylvieAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ShieldOfSylvie;
        this.__typeName = "ShieldOfSylvie";
    }
}
exports.ShieldOfSylvieAbilityArgs = ShieldOfSylvieAbilityArgs;
let ShieldOfSylvieActorAbilityFactory = class ShieldOfSylvieActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ShieldOfSylvie", "AllAllies", 4);
    }
};
ShieldOfSylvieActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ShieldOfSylvie")
], ShieldOfSylvieActorAbilityFactory);
exports.ShieldOfSylvieActorAbilityFactory = ShieldOfSylvieActorAbilityFactory;
let ShieldOfSylvieAbilityHandler = class ShieldOfSylvieAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        sequence.push(new core_1.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "Regeneration", "casting"));
        sequence = sequence.pushSequence("parallel");
        for (const ally of allies) {
            container.applyBuff({
                sequence: sequence.pushSequence("sequential"),
                creatorId: ability.invokerId,
                targetId: ally,
                duration: Duration_1.Duration.Turns(4),
                effect: new core_2.LinkedEffectsEffectArgs([
                    new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Health, container.getPercentOfBaseHealth(ally, 20)),
                    new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(ally, 10, "Toughness")),
                ], false),
                onApplied: (sequence) => {
                    sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ally, "chest"), "MagicBubble"));
                }
            });
        }
    }
};
ShieldOfSylvieAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ShieldOfSylvie)
], ShieldOfSylvieAbilityHandler);
exports.ShieldOfSylvieAbilityHandler = ShieldOfSylvieAbilityHandler;
